<template>
  <div class="create_mass">
    <div class="create_mass_top" @click="returnPage">
      <svg t="1620721128077" class="icon title" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16607" width="16" height="16"><path d="M736 1024l-512-512 505.6-512 70.4 70.4L358.4 512l441.6 448L736 1024z" p-id="16608"></path></svg>
      <span class="title" style="margin-left: 5px;">新建群发</span>
    </div>
    <div class="content">
      <div class="mass_detail">
        <h4>
          基础信息
          <div class="divider" style="padding-left:0px;padding-right:0px;width:px;">
            <span class="ant-divider"></span>
          </div>
        </h4>
        <div class="mass_item">
          <span class="title" style="padding-top: 6px;">群发名称：</span>
          <el-input v-model="form.name" placeholder="群发名称仅内部可见"></el-input>
        </div>
        <div class="mass_item account_selection">
          <span class="title" style="margin-right: 3px;width: 89px;">选择群主：</span>
          <el-select v-model="group_leader.name" placeholder="请选择" multiple filterable allow-create default-first-option @focus="getCustomerBaseLeader" style="width: 320px; margin-left: 9px;">
            <el-option
                v-for="item in group_leader.list"
                :key="item.userid"
                :label="item.name"
                :value="item.userid">
            </el-option>
          </el-select>

<!--          <div class="group_box" @click="open_select_group">-->
<!--            <div class="placeholder" v-show="showGroupInfo.list.length === 0">-->
<!--              <span>请选择群聊</span>-->
<!--              <i>-->
<!--                <svg t="1620617928673" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5657" width="16" height="16"><path d="M513.3 747c-7 0-13.9-2.9-18.8-8.5-9.1-10.4-8-26.2 2.4-35.3l351.3-307c10.4-9.1 26.2-8 35.3 2.4 9.1 10.4 8 26.2-2.4 35.3l-351.3 307c-4.8 4-10.6 6.1-16.5 6.1z" p-id="5658" fill="#707070"></path><path d="M512.6 746c-5.8 0-11.7-2-16.4-6.2l-351.3-307c-10.4-9.1-11.5-24.9-2.4-35.3 9.1-10.4 24.9-11.5 35.3-2.4l351.3 307c10.4 9.1 11.5 24.9 2.4 35.3-5 5.7-11.9 8.6-18.9 8.6z" p-id="5659" fill="#707070"></path></svg>-->
<!--              </i>-->
<!--            </div>-->
<!--            <div class="group_list_wrap" v-show="showGroupInfo.list.length !== 0">-->
<!--              <div class="group_list">-->
<!--                <div class="group">-->
<!--                  <img class="avatar" src="https://wework.qpic.cn/wwhead/nMl9ssowtibVGyrmvBiaibzDguNrzNMXFApjaJPXy8OFhQRqYianAu4CIv01ibicrthUUBCUD5aq6VJPQ/60" alt="">-->
<!--                  <span class="name">{{showGroupInfo.info.name}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

        </div>

        <h4 style="margin-top: 45px;">
          编辑群发消息
          <div class="divider" style="padding-left:0px;padding-right:0px;width:px;">
            <span class="ant-divider"></span>
          </div>
        </h4>
        <div class="mass_item">
          <span class="title" style="padding-top: 6px;">群发消息：</span>
          <el-input
              type="textarea"
              :rows="7"
              placeholder="请输入内容"
              maxlength="1000"
              show-word-limit
              v-model="form.message">
          </el-input>
        </div>
        <div class="message2-pay-attention">
          <span>注意：</span>
          <div class="attention-items">
            <p>每个群聊每个自然月最多接受来自统一企业管理员的 4 条群发消息，4条消息可在同一天发送</p>
          </div>
        </div>
        <div class="mass_item">
          <span class="title">群发时间：</span>
          <div>
            <div class="tabs">
              <el-radio v-model="form.radio" :label=1>立即发送</el-radio>
              <el-radio v-model="form.radio" :label=2>定时发送</el-radio>
            </div>
            <div class="time-box" v-show="form.radio === 2">
              <el-date-picker
                  v-model="form.time"
                  type="datetime"
                  placeholder="选择日期时间">
              </el-date-picker>
            </div>
          </div>
        </div>
        <el-button class="notice" @click="openAdd">通知成员发送</el-button>
      </div>
      <div class="preview-container">
        <p class="title">客户收到的消息</p>
        <div class="phone-preview-content">
          <img class="bg" src="https://assets.weibanzhushou.com/web/we-work-webapp/phone.1c130fa643cd.png" alt="">
          <div class="preview-content">
            <p class="date">12:00</p>
            <div class="inner" v-show="form.message != ''">
              <div class="message message-text">
                <img class="avatar" src="https://assets.weibanzhushou.com/web/we-work-webapp/avatar-default.af3289dacfcf.svg" alt="">
                <div>
                  {{form.message}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog :show.sync.sync="select_group_show" :name_width="select_group_dialog" class="select_group_dialog">
      <span slot="body">
        <div class="group_box">
          <div class="group_list">
            <div style="padding-right: 20px; padding-bottom: 20px">
              <el-input
                  placeholder="请输入成员昵称"
                  v-model="groupForm.group_name">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="title">全部成员：（{{groupForm.list.length}}）</div>
            <div class="list">
              <div class="list_item" @click="clickItem(value, index)" v-for="(value, index) in groupForm.list">
                <div class="item_content">
                  <img class="avatar" src="https://wework.qpic.cn/wwhead/nMl9ssowtibVGyrmvBiaibzDguNrzNMXFApjaJPXy8OFhQRqYianAu4CIv01ibicrthUUBCUD5aq6VJPQ/60" alt="">
                  <div class="group_info">
                    <span class="name">{{value.name}}</span>
                  </div>
                  <div class="action">
                    <i>
                      <svg v-show="value.checked === true" t="1620627286226" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8363" width="20" height="20"><path d="M527.519973 877.43083c-51.583842 0-101.629655-10.105149-148.749836-30.036084-45.50745-19.24839-86.37216-46.798862-121.464399-81.891102s-62.644759-75.958996-81.892125-121.465422c-19.930935-47.120181-30.036084-97.167017-30.036084-148.750859 0-51.584865 10.105149-101.630678 30.036084-148.750859 19.249413-45.506427 46.799886-86.373183 81.892125-121.465422 35.092239-35.092239 75.958996-62.644759 121.464399-81.892125 47.120181-19.929912 97.165993-30.03506 148.749836-30.03506 51.584865 0 101.631702 10.105149 148.750859 30.03506 45.50745 19.24839 86.373183 46.799886 121.465422 81.892125 35.092239 35.092239 62.644759 75.958996 81.891102 121.466446 19.930935 47.119157 30.036084 97.16497 30.036084 148.749836 0 51.583842-10.105149 101.630678-30.036084 148.750859-19.24839 45.506427-46.798862 86.373183-81.891102 121.465422s-75.958996 62.644759-121.465422 81.891102C629.151675 867.325681 579.104839 877.43083 527.519973 877.43083zM889.197316 495.28634M165.842631 495.28634M485.271754 643.157155 711.679273 394.624732c3.805676-4.178159 3.504824-10.650571-0.673335-14.456247s-10.650571-3.5038-14.456247 0.673335l-219.675188 241.142106L326.597895 491.37117c-4.266164-3.708462-10.730389-3.255137-14.435781 1.010003-3.707438 4.26514-3.255137 10.729365 1.010003 14.436804l157.822468 137.171126c1.936095 1.682315 4.326539 2.509147 6.709819 2.509147C480.485751 646.49825 483.255841 645.370567 485.271754 643.157155z" p-id="8364" fill="#27A538"></path></svg>
                      <svg v-show="value.checked === false" t="1620627324743" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9328" width="18" height="18"><path d="M812.698413 212.746384c79.825044 79.825044 121.362963 180.238448 124.613757 300.517813-3.250794 119.918166-44.788713 219.97037-124.613757 300.156614-79.825044 80.186243-179.877249 121.724162-299.795414 124.252557-120.640564-2.528395-220.692769-44.066314-300.517813-124.252557-79.825044-80.186243-121.362963-180.238448-124.613757-300.156614 3.250794-120.640564 44.788713-220.692769 124.613757-300.517813 79.825044-79.825044 179.877249-121.362963 300.517813-124.613757C633.182363 91.383422 732.873369 132.92134 812.698413 212.746384zM786.692063 791.387654c72.962257-72.962257 110.888183-164.345679 114.138977-274.150265-3.250794-109.804586-41.17672-201.188007-114.138977-274.150265-72.601058-72.962257-163.98448-110.888183-273.789065-113.416578C402.737213 131.837743 311.353792 169.763668 238.391534 243.087125c-72.962257 72.962257-110.888183 164.345679-114.138977 274.150265 3.250794 109.804586 41.17672 201.188007 114.138977 274.150265 72.601058 72.962257 164.345679 110.888183 274.872663 113.416578C622.707584 902.275838 714.091005 864.349912 786.692063 791.387654z" p-id="9329" fill="#515151"></path></svg>
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="selected_list">
            <div class="title">已选成员（{{thisGroupForm.list.length}}）</div>
            <div class="list">
              <div class="list_item" v-for="(value, index) in thisGroupForm.list">
                <div class="item_content">
                  <img class="avatar" src="https://wework.qpic.cn/wwhead/nMl9ssowtibVGyrmvBiaibzDguNrzNMXFApjaJPXy8OFhQRqYianAu4CIv01ibicrthUUBCUD5aq6VJPQ/60" alt="">
                  <div class="group_info">
                    <span class="name">{{value.name}}</span>
                  </div>
                  <div class="action">
                    <i>
                      <svg @click="delGroup(value, index)" t="1620626400017" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6623" width="20" height="20"><path d="M551.424 512l195.072-195.072c9.728-9.728 9.728-25.6 0-36.864l-1.536-1.536c-9.728-9.728-25.6-9.728-35.328 0L514.56 475.136 319.488 280.064c-9.728-9.728-25.6-9.728-35.328 0l-1.536 1.536c-9.728 9.728-9.728 25.6 0 36.864L477.696 512 282.624 707.072c-9.728 9.728-9.728 25.6 0 36.864l1.536 1.536c9.728 9.728 25.6 9.728 35.328 0L514.56 548.864l195.072 195.072c9.728 9.728 25.6 9.728 35.328 0l1.536-1.536c9.728-9.728 9.728-25.6 0-36.864L551.424 512z" fill="#515151" p-id="6624"></path></svg>
                    </i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
      <div slot="footer">
        <el-button type="primary" @click="save_select_group">确 定</el-button>
        <el-button @click="close_select_group">取 消</el-button>
      </div>
    </Dialog>

    <Dialog :show.sync.sync="add_show" :name_width="add_dialog" class="select_group_dialog">
      <span slot="body">
        <span>确定为 {{select_group_name.join('、')}} 创建群群发任务？</span>
      </span>
      <div slot="footer">
        <el-button type="primary" @click="save_add">创 建</el-button>
        <el-button @click="close_add">取 消</el-button>
      </div>
    </Dialog>



  </div>
</template>

<script>
import {getCustomerBaseLeader, addCustomerBaseMassSend} from 'network/hk_qiwei'

import Dialog from "components/content/dialog/Dialog";

export default {
  name: "CreateMass",
  components: {
    Dialog
  },
  data() {
    return {
      select_group_show: false,
      select_group_dialog: {
        name: '选择群聊',
        width: '630px'
      },
      add_show: false,
      add_dialog: {
        name: '新建群发',
        width: '400px'
      },
      remind_show: false,
      remind_dialog: {
        name: '提醒发送',
        width: '400px'
      },

      // 群主列表
      group_leader: {
        name: [],
        list: []
      },
      // 选择的群主
      select_group_name: [],

      tab_url: '',
      form: {
        name: '',
        message: '',
        radio: 1,
        time: null,
      },


      // 选择群聊数据
      groupForm: {
        group_name: '',
        list: [
          {
            name: '刘嘉铭',
            checked: false
          },{
            name: '刘嘉铭',
            checked: false
          }
        ]
      },
      thisGroupForm: {
        list: []
      },
      showGroupInfo: {
        info: {
          name: ''
        },
        list: []
      },


      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now();
        },
      },
    }
  },
  created() {
    this.tab_url = this.$route.query.url;
  },
  methods: {
    returnPage() {
      this.$router.push({path: this.tab_url})
    },


    // 选择群主弹窗
    open_select_group() {
      this.select_group_show = true
    },
    save_select_group() {
      if (this.thisGroupForm.list.length !== 0) {
        this.showGroupInfo.list = this.thisGroupForm.list
        this.showGroupInfo.info = this.thisGroupForm.list[0]
      }

      this.select_group_show = false
    },
    close_select_group() {
      this.select_group_show = false
    },
    clickItem(value, index) {
      if (value.checked) {
        let index1 = this.thisGroupForm.list.indexOf(value)
        this.thisGroupForm.list.splice(index1, 1)
      } else {
        this.thisGroupForm.list.push(value)
      }
      this.groupForm.list[index].checked = !this.groupForm.list[index].checked
    },
    delGroup(value, index) {
      this.thisGroupForm.list.splice(index, 1)

      let index1 = this.groupForm.list.indexOf(value)
      this.groupForm.list[index1].checked = !this.groupForm.list[index1].checked
    },


    // 通知成员发送
    openAdd() {
      this.select_group_name = []
      this.group_leader.list.map((value) => {
        if (this.group_leader.name.indexOf(value.userid) !== -1) {
          this.select_group_name.push(value.name)
        }

      })

      this.add_show = true
    },
    save_add() {
      if (this.group_leader.name.length === 0) {
        this.$message({
          message: '请选择群主',
          type: 'warning',
          offset: 100
        });
      } else if (this.form.name == '') {
        this.$message({
          message: '请输入群发名称',
          type: 'warning',
          offset: 100
        });
      } else if (this.form.message == '') {
        this.$message({
          message: '请输入群发消息',
          type: 'warning',
          offset: 100
        });
      } else if (this.form.radio === 2 && this.form.time == null) {
        this.$message({
          message: '请选择群发时间',
          type: 'warning',
          offset: 100
        });
      } else {
        this.addCustomerBaseMassSend(this.group_leader.name.join()+',', this.form.name, this.form.message, this.form.radio, this.form.time/1000)
      }
    },
    close_add() {
      this.add_show = false
    },



    // 获取群主列表
    getCustomerBaseLeader() {
      getCustomerBaseLeader().then(res => {
        if (res.code === 10000) {
          this.group_leader.list = res.message
        }
      })
    },
    // 创建任务
    addCustomerBaseMassSend(userid, name, content, send_type, send_time) {
      addCustomerBaseMassSend(userid, name, content, send_type, send_time).then(res => {
        if (res.code === 10000) {
          this.$message({
            message: '新建成功',
            type: 'success',
            offset: 100
          });
          this.add_show = false
          this.$router.push({path: '/qiwei/group_mass/mass_list'})
        }
      })
    },

  }
}
</script>

<style scoped>
.create_mass .create_mass_top {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 15px;
}
.create_mass .create_mass_top .title {
  cursor: pointer;
}

.content {
  margin-top: 10px;
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  border-radius: 2px;
  padding-top: 30px;
  padding-left: 29px;
  padding-right: 42px;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: start;
  justify-content: flex-start;
  box-sizing: border-box;
}
.content .mass_detail {
  max-width: 900px;
  -webkit-box-flex: 1;
  flex: 1;
  width: 0;
  margin-right: 50px;
  position: relative;
}
.content .mass_detail h4{
  font-weight: 500;
  font-size: 15px;
  color: rgba(0,0,0,.85);
  margin-bottom: 0;
}
.content .mass_detail h4 .ant-divider{
  margin-top: 12px;
  margin-bottom: 18px;
  display: block;
  clear: both;
  width: 100%;
  min-width: 100%;
  height: 1px;
  padding: 0;
  color: rgba(0,0,0,.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  -webkit-font-feature-settings: "tnum";
  font-feature-settings: "tnum";
  background: #e8e8e8;
  vertical-align: middle;
  position: relative;
  top: -.06em;
}
.mass_detail .mass_item {
  display: -webkit-box;
  display: flex;
  margin-bottom: 24px;
  position: relative;
}
.mass_detail .account_selection .title {
  width: 100px;
  text-align: right;
  margin-right: 12px;
  font-size: 14px;
  color: #333;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: end;
  justify-content: flex-end;
}
.mass_detail .mass_item .title {
  width: 100px;
  text-align: right;
  margin-right: 12px;
  font-size: 14px;
  color: #333;
  line-height: 20px;
}
.message2-pay-attention {
  background: #f7fcff;
  border-radius: 3px;
  border: 1px solid #acd7ff;
  display: -webkit-box;
  display: flex;
  font-size: 12px;
  line-height: 22px;
  padding: 15px;
  margin-left: 101px;
  margin-bottom: 24px;
  position: relative;
  color: rgba(0,0,0,.65);
}
.message2-pay-attention>span {
  width: 36px;
  margin-right: 8px;
}
.mass_item .time-box {
  display: flex;
  margin-top: 10px;
}
.mass_detail .notice {
  background: var(--themeColors);
  color: #fff;
  padding: 0 15px;
  height: 32px;
  border: none;
  margin-left: 112px;
  margin-bottom: 35px;
}
.mass_detail .notice:hover {
  background: var(--themeColorsHover);
}

.content .preview-container {
  width: 280px;
  flex-shrink: 0;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  margin-top: 50px;
}
.preview-container .title {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0,0,0,.85);
  text-align: center;
  margin-bottom: 24px;
}
.preview-container .phone-preview-content {
  position: absolute;
  top: 180px;
  width: 274px;
  height: 535px;
}
.phone-preview-content .bg {
  width: 274px;
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
}
.phone-preview-content .preview-content {
  width: 235px;
  height: 343px;
  padding: 23px 7px 7px;
  background: transparent;
  position: relative;
  z-index: 2;
  left: 20px;
  top: 98px;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  box-sizing: border-box;
}
.phone-preview-content .preview-content .date {
  text-align: center;
  font-size: 10px;
  color: #999;
  line-height: 13px;
  position: absolute;
  top: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
.phone-preview-content .preview-content .inner {
  -webkit-box-flex: 1;
  flex: 1;
  padding-right: 9px;
  overflow: auto;
}
.phone-preview-content .preview-content .message {
  width: 100%;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: start;
  justify-content: flex-start;
  margin-bottom: 17px;
  box-sizing: border-box;
}
.phone-preview-content .preview-content .message>.avatar {
  width: 26px;
  height: 26px;
  margin-right: 8px;
  display: inline-block;
  border-radius: 2px;
}
.phone-preview-content .preview-content .message-text>div {
  max-width: 183px;
  background: #fff;
  border-radius: 2px;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding: 7px 11px;
  font-size: 12px;
  word-break: break-all;
  white-space: pre-wrap;
  position: relative;
  box-sizing: border-box;
  color: rgba(0,0,0,.65);
}
.phone-preview-content .preview-content .message-text>div:after {
  box-sizing: content-box;
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  border: 3px solid transparent;
  border-right-color: #fff;
  position: absolute;
  left: -6px;
  top: 5px;
}


.mass_item .group_box {
  margin: 0 10px;
  width: 200px;
  height: 36px;
  background: #fff;
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  cursor: pointer;
}
.mass_item .group_box .placeholder {
  color: rgba(0,0,0,.25);
  height: 100%;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 0 10px;
}
.mass_item .group_box .group_list_wrap {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  height: 36px;
}
.mass_item .group_box .group_list_wrap .group_list {
  max-width: 180px;
  width: 180px;
  height: 100%;
  padding-left: 10px;
  overflow: hidden;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}
.mass_item .group_box .group_list_wrap .group_list .group {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  margin-right: 4px;
}
.mass_item .group_box .group_list_wrap .group_list .group .avatar {
  width: 24px;
  margin-right: 2px;
  display: inline-block;
  border-radius: 2px;
  vertical-align: middle;
  border-style: none;
}
.mass_item .group_box .group_list_wrap .group_list .group .name {
  max-width: 145px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
.select_group_dialog .group_box {
  height: 366px;
  width: 100%;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}
.select_group_dialog .group_box .group_list {
  position: relative;
  -webkit-box-flex: 1;
  flex: 1;
  height: 100%;
  border-right: 1px solid #eaebed;
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  width: 50%;
}
.group_box .group_list .title {
  color: #666;
  font-size: 13px;
}
.group_box .group_list .list, .group_box .selected_list .list {
  margin-top: 8px;
  overflow: auto;
  -webkit-box-flex: 1;
  flex: 1;
  box-sizing: border-box;
}
.group_box .group_list .list .list_item, .group_box .selected_list .list .list_item{
  width: 100%;
  margin-bottom: 10px;
  height: 50px;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  cursor: pointer;
  padding: 10px 20px 10px 0;
  box-sizing: border-box;
}
.group_box .group_list .list .list_item:hover {
  background: rgb(234,247,238);
}
.group_box .group_list .list .list_item .item_content, .group_box .selected_list .list .list_item .item_content {
  -webkit-box-flex: 1;
  flex: 1;
  overflow: hidden;
  margin-right: 10px;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}
.group_box .group_list .list .list_item .item_content .avatar, .group_box .selected_list .list .list_item .item_content .avatar{
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.group_box .group_list .list .list_item .item_content .group_info, .group_box .selected_list .list .list_item .item_content .group_info {
  width: 197px;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  box-sizing: border-box;
}
.group_box .group_list .list .list_item .item_content .group_info .name, .group_box .selected_list .list .list_item .item_content .group_info .name {
  color: rgba(0,0,0,.65);
  font-size: 14px;
  -webkit-box-flex: 1;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
.group_box .group_list .list .list_item .item_content .group_info .group_total, .group_box .selected_list .list .list_item .item_content .group_info .group_total {
  font-size: 12px;
  color: rgba(0,0,0,.45);
}
.select_group_dialog .group_box .selected_list {
  width: 50%;
  height: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  padding-left: 20px;
}
.select_group_dialog .group_box .selected_list .title {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.85);
}
</style>